<div class="header" >
  <div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
    <div class="contentInner">
      <div class="pageTitle">
        <h1 class="headline">Terms of service</h1>
      </div>
    </div>
  </div>
</div>
<div class="content">
  <div class="contentInner">
    <h2 class="sectionHeader">Dash terms of service</h2>
    <p class="intro">This terms of service agreement is entered into between Apt Software Ltd. ('Apt Software', 'Dash',
      'we', or 'us'), and all users of our Services or Mobile Apps ('you' and 'your').  By accessing any of our Services, or
      by downloading and using any of our Mobile Apps (hereafter referred to as the 'Service') you agree to be bound by
      these Terms.</p>

     <p> We may from time to time vary these Service Terms. Please check these Service Terms regularly to ensure you are aware of
      any variations made by us. If you continue to use the Service, you are deemed to have accepted such variations. If
      you do not agree to such variations, you should not use the Service.
    </p>

    <h3>Prohibited Use</h3>
    <p>You agree not to use the Service in any way that:
    </p>
    <ul>
      <li>allow any third party to access or use the Service with your Account Credentials;</li>
      <li>sell or sublicense the Service;</li>
      <li>use the Service in any way that is unlawful, illegal or unauthorised;</li>
      <li>access data or information that you are not authorised to access;</li>
      <li>interfere with or disrupt the performance of the Service; or</li>
      <li>permit third parties to do any of the above.</li>
    </ul>

    <h3>Changes to Service</h3>
    <p>From time to time, we may issue an update to the Service which may add, modify, and/or remove features from the
      Service. These updates may be launched automatically with no notice, although we may make reasonable efforts to
      notify you in advance of an upcoming update.  You agree that Apt Software Ltd. will not be liable to you for any
      modification, or suspension of the Service or any features or functions thereof.
    </p>

    <h3>Warranty</h3>
    <p><b>THE SERVICE AND THE INFORMATION, SOFTWARE, PRODUCTS AND SERVICES ASSOCIATED WITH IT ARE PROVIDED “AS IS.” WE
      AND/OR OUR SUPPLIERS, LICENSORS, PARTNERS AND AFFILIATES DISCLAIM ANY WARRANTY OF ANY KIND, WHETHER EXPRESS OR
      IMPLIED, AS TO ANY MATTER WHATSOEVER RELATING TO THE SERVICE AND ANY INFORMATION, SOFTWARE, PRODUCTS AND SERVICES
      PROVIDED HEREIN, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
      PURPOSE, TITLE, AND NONINFRINGEMENT. USE OF OUR SERVICE IS AT YOUR OWN RISK.</b>
    </p>

    <h3>Liability</h3>

    <p>To the fullest extent permitted under applicable law, in no event shall Apt Software Ltd. be liable to you with
      respect to use of the service and/or be liable to you for any direct, indirect, special or consequential damages
      including, without limitation, damages for loss of goodwill, lost profits, or loss, theft or corruption of your
      information, the inability to use the Service, Device failure or malfunction.
    </p>

    <p>Apt Software Ltd. shall not be liable even if it has been advised of the possibility of such damages, including
      without limitation damages caused by error, omission, interruption, defect, failure of performance, unauthorised
      use, delay in operation or transmission, line failure, computer virus, worm, Trojan horse or other harm.
    </p>

    <p>In the event that applicable law does not allow the exclusion of certain promises and/or the exclusion of
      liability for direct, indirect, consequential or other damages, in no event shall Apt Software Ltd’s liability
      arising under or in connection with these App Terms and your use of the App exceed your current
      Service Fees paid by you for the Service.
    </p>


    <h3>Mobile and Web Apps</h3>

    <p>We make various Apps available to access the Service via a mobile device or a web browser. To use the
      Apps you must have a mobile device or web browser that is compatible with our Apps. We do not warrant that the Apps will
      be compatible with your mobile device or web browser. We grant to you a non-exclusive, non-transferable, revocable license to
      use a compiled code copy of each Mobile App on as many devices as you are permitted to by the subscription you
      have subscribed to.
    </p>

    <p>The Service offers functionality and various tools that are available to you via your mobile phone or
      other mobile computing device (collectively, "Mobile Services"). Please note that your mobile carrier's normal
      messaging, data, and other rates and fees will apply to your use of the Mobile Services. In addition, downloading,
      installing, or using certain Mobile Services may be prohibited or restricted by your mobile carrier, and not all
      Mobile Services may work with all carriers or devices or in all locations. Therefore, you are solely responsible
      for checking with your mobile carrier to determine if the Mobile Services are available for your mobile devices;
      what restrictions, if any, may be applicable to your use of the Mobile Services; and how much such use will cost
      you. Nevertheless, all use of the Service, including without limitation all use of the Apps and their related
      Mobile Services, shall be strictly in accordance with this Agreement.
    </p>

    <h3>Fee & Subscription</h3>
    <p>The Service is provided, per the terms of this Agreement, without an additional fee unless you have activated the
      premium features by purchasing a subscription to that service.</p>

    <h4>"In-app" Subscriptions</h4>
    <p>An "in-app" subscription is a subscription purchased directly from the Dash mobile app, which will enable all premium features connected to
      that subscription. Subscriptions renew on a periodic basis (as designated by Apt Software Ltd.) unless you
      indicate and request non-renewal through the participating mobile app provider, such as Google Play or Apple
      iTunes, from which you originally downloaded the application. Subscription payments will be processed by the
      participating mobile app provider. You may access the applicable "in-app" purchase rules and policies directly
      from the applicable app store(s). Additional terms or conditions may apply to a subscription at the time of
      order or renewal.</p>

    <h4>"Enterprise" Subscriptions</h4>
    <p>An "Enterprise" subscription is a subscription purchased directly through us or through our merchant partners,
      and licensed via a key.  The subscription licenses you a non-exclusive, non-transferable, revocable right to use
      the premium features connected to that subscription, on the number of devices specified in the subscription, for
      the subscription term, for Your own and Your Affiliates’ internal purposes.
    </p>

    <h3>Restrictions</h3>

    <p>The following uses and/or activities are not permitted unless otherwise specifically allowed by Apt Software Ltd.
      under the terms of a separate agreement:</p>
    <ul>
      <li>Modifying, translating, decompiling, reverse engineering, redistributing or retransmitting in any form or by any means, the Service or any portion thereof;</li>
      <li>Creating any derivative products or other works using any portion of the Service;</li>
      <li>Using the Service or any portion thereof in any third party product or service; and</li>
      <li>Sharing passwords and/or access codes with third parties, or allowing any non-End User to use the Product.</li>
    </ul>

    <p>In addition, if you are using our hosted web dashboard:</p>

    <p>You may not  (A) attempt to circumvent user authentication or the security of any host, network, or account
      (aka “cracking”), including, but not limited to, accessing data not intended for you, logging into a server or
      account that you are not expressly authorized to access, or probing the security of Apt Software Ltd. servers and
      networks, or (B) create a denial of service, impede the operation of the Service or engage in any activities that
      adversely affect the ability of other End Users to use the Service.
    </p>

    <p>
      You may not upload, share or otherwise transmit any content that (A) You do not have a right to upload, share
      or transmit under any law or under contractual or fiduciary relationships; or (B) violates anyone's copyright,
      trademark or other proprietary right.
    </p>

    <h3>Intellectual Property</h3>

    <p>The Service may be protected by copyright, trademark, and other laws of New Zealand, United States,
      and foreign countries. Apt Software Ltd. exclusively owns all right, title and interest in and to the Service,
      including all associated intellectual property rights. Without limiting the foregoing, you may not duplicate or
      reuse any portion of the code or visual design elements of the Service without express written consent from
      Apt Software Limited.
    </p>

    <h3>General</h3>
    <p>Terms of Service shall be governed by the laws of New Zealand. For any matters which are not regulated within
      these Terms of Service provision of the the Law of New Zealand apply. Any disputes resulting from these Terms and
      Conditions or the Agreement shall be finally resolved by a New Zealand civil court.
    </p>

    <h3>Acceptance of Terms</h3>

    <p>These Terms of Service, together with the <a routerLink="/privacy-policy">Privacy Policy</a> and any other legal
      notices published by us on the Service, shall constitute the entire agreement between you and us concerning this
      Service and supersedes any prior written or oral representations. <b>BY USING OUR SERVICE, YOU ARE ACCEPTING THE
        PRACTICES SET OUT IN THESE TERMS OF SERVICE.</b></p>

    <p>If we decide to change our Terms, we will post those changes to this Terms of Service page and any other
      places we deem appropriate. We reserve the right to modify these Terms at any time, so please review this document
      frequently. If we make material changes to our Terms, we will notify you here, or by other means, such as e-mail,
      at our discretion.</p>

    <p>Your continued use of any portion of our Service following posting of the updated Terms will constitute your
      acceptance of the Terms stated above and any changes made to these Terms.  If you do not agree to these Terms,
      then you may not use the Service.
    </p>

    <p><b>YOU AND WE AGREE THAT ANY CAUSE OF ACTION
      ARISING OUT OF OR RELATED TO THIS SERVICE MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES.
        OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.</b> These Terms of Service may not be transferred or assigned
      by you, but may be assigned by us without restriction. Any attempted transfer or assignment in violation hereof
      shall be null and void. All rights not expressly granted herein are reserved to us.</p>

    <h3>Effective Date</h3>
    <p>This terms of service agreement was last revised on May 10, 2023.</p>

    <p>Copyright © 2019-2025 Apt Software Ltd. All Rights Reserved.</p>

  </div>
</div>
